import { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft, Printer, DownloadSimple, GearSix } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { downloadFile } from "@/lib/api";
import { LabelSheet, LABEL_KINDS, LABEL_PRINT_CSS, useLabelData } from "@/components/LabelDialog";

export default function InstallLabel() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const kind = LABEL_KINDS.includes(params.get("kind")) ? params.get("kind") : "Install";
  const { d, err } = useLabelData(id, kind, true);
  const [busy, setBusy] = useState(false);

  const pdf = async () => {
    setBusy(true);
    try {
      await downloadFile(`/jobs/${id}/install-label.pdf?kind=${kind}`,
        `${kind.toLowerCase()}-label-${d?.job_code || id}.pdf`);
    } catch {
      toast.error("Could not download PDF");
    }
    setBusy(false);
  };

  if (err) return <div className="p-6 text-sm text-red-400">{err}</div>;
  if (!d) return <div className="p-6 text-sm text-zinc-500">Loading label…</div>;

  return (
    <div className="grain min-h-screen">
      <style>{LABEL_PRINT_CSS}</style>
      <div className="no-print mx-auto flex max-w-xl items-center gap-2 px-4 py-4">
        <Button variant="ghost" size="sm" onClick={() => navigate(-1)} data-testid="label-back-btn">
          <ArrowLeft size={15} weight="bold" className="mr-1" /> Back
        </Button>
        <div className="ml-3 flex overflow-hidden rounded-md border border-zinc-800" data-testid="label-kind-toggle">
          {LABEL_KINDS.map((k) => (
            <button
              key={k}
              type="button"
              data-testid={`label-kind-${k.toLowerCase()}`}
              onClick={() => setParams({ kind: k })}
              className={`h-8 px-3 text-[10px] font-bold uppercase tracking-widest transition-colors duration-150 ${
                kind === k ? "bg-indigo-500 text-white" : "text-zinc-400 hover:bg-zinc-800"
              }`}
            >
              {k}
            </button>
          ))}
        </div>
        <div className="ml-auto flex gap-2">
          <Button variant="outline" size="sm" onClick={() => navigate("/settings/install-label")}
            data-testid="label-settings-btn">
            <GearSix size={15} weight="bold" className="mr-1" /> Fields
          </Button>
          <Button variant="outline" size="sm" onClick={pdf} disabled={busy} data-testid="label-pdf-btn">
            <DownloadSimple size={15} weight="bold" className="mr-1" /> PDF
          </Button>
          <Button size="sm" onClick={() => window.print()} data-testid="label-print-btn">
            <Printer size={15} weight="bold" className="mr-1" /> Print {kind} 4×6
          </Button>
        </div>
      </div>
      <LabelSheet d={d} />
    </div>
  );
}
